/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Tasks_Kanban_Column_EmptyInputs */

const en_my_tasks_kanban_column_empty = /** @type {(inputs: My_Tasks_Kanban_Column_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks here.`)
};

const pt_br2_my_tasks_kanban_column_empty = /** @type {(inputs: My_Tasks_Kanban_Column_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade aqui.`)
};

/**
* | output |
* | --- |
* | "No tasks here." |
*
* @param {My_Tasks_Kanban_Column_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const my_tasks_kanban_column_empty = /** @type {((inputs?: My_Tasks_Kanban_Column_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Tasks_Kanban_Column_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_tasks_kanban_column_empty(inputs)
	return pt_br2_my_tasks_kanban_column_empty(inputs)
});